import { Component, OnInit } from '@angular/core';
import { BillingControlService } from './service/billing-control.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-billing-control',
  templateUrl: './billing-control.component.html',
  styleUrls: ['./billing-control.component.scss'],
  providers: [BillingControlService]
})
export class BillingControlComponent implements OnInit {

  private routerSub: any;
  private selectedDirectorship = null;

  constructor(private billingControlService: BillingControlService,
              private flashMessagesService: FlashMessagesService, 
              private router: Router, 
              private route: ActivatedRoute) { 

		this.routerSub = this.route.params.subscribe(params => {
			this.selectedDirectorship = params['idDiretoria'];
    });
    this.billingControlService.setBCDays();
  }
  
  ngOnInit() {
    if (this.selectedDirectorship){
      this.billingControlService.selectedDirectorship = this.selectedDirectorship;
    }
  }

  getDirectorshipDetails(){
    
  }


  // Verificar o numero de dias: cobranca

}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/billing-control.component.ts